import React, { ReactElement, useState } from 'react'
import { ContainerTabela } from '@pages/style'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, List, Popconfirm } from 'antd'
import { HeaderPage } from '@components/atoms'
import api from '@services/api'
import { useFetch, useRouter } from '@customHooks'
import { IFeriado } from '@app'
import { format, parseISO } from 'date-fns'

export default function Feriados(): ReactElement {
  const { navigate } = useRouter()
  const [reload, setReload] = useState(false)

  const { apiData: feriados, isLoading } = useFetch<IFeriado>({
    url: '/feriado',
    reload,
  })

  const onDelete = async (id: number) => {
    await api.delete(`/feriado/${id}`).then(() => setReload(!reload))
  }

  return (
    <ContainerTabela>
      <HeaderPage
        title='Feriados'
        extra={[
          <Button
            key='insert'
            icon={<PlusOutlined />}
            size='large'
            type='primary'
            onClick={() => navigate('novo')}
          >
            Novo Feriado
          </Button>,
        ]}
      />
      <List
        style={{ backgroundColor: '#FFF' }}
        itemLayout='horizontal'
        bordered
        dataSource={feriados}
        loading={isLoading}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key='edit'
                onClick={() =>
                  navigate(`${item.ID_FERIADO}`, {
                    state: item,
                  })
                }
                type='link'
                icon={<EditOutlined />}
              >
                Editar
              </Button>,
              <Popconfirm
                key='delete'
                title='Deseja realmente excluir este registro?'
                onConfirm={() => onDelete(item.ID_FERIADO)}
              >
                <Button type='text' icon={<DeleteOutlined />}>
                  Apagar
                </Button>
              </Popconfirm>,
            ]}
          >
            <List.Item.Meta
              title={item.DESCFERIADO}
              description={format(parseISO(item.DATA_FERIADO), 'dd/MM/yyyy')}
            />
          </List.Item>
        )}
      />
    </ContainerTabela>
  )
}
